export enum ResourceTypeKeys {
  SET_CLARITYFIRST_VIDEO = 'resource/SET_CLARITYFIRST_VIDEO',
}

export interface IResourceState {
  showClarityFirstVideo?: boolean;
}
